import React from "react";

function MessageIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.8335 7.08301L8.28518 8.53251C9.7145 9.37759 10.2858 9.37759 11.7152 8.53251L14.1668 7.08301"
        stroke="#424242"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.67964 11.23C1.73412 13.7846 1.76136 15.0619 2.70397 16.0081C3.64657 16.9544 4.95845 16.9873 7.5822 17.0532C9.19926 17.0939 10.8004 17.0939 12.4175 17.0532C15.0413 16.9873 16.3531 16.9544 17.2957 16.0081C18.2383 15.0619 18.2656 13.7846 18.32 11.23C18.3376 10.4086 18.3376 9.59202 18.32 8.77068C18.2656 6.21604 18.2383 4.93873 17.2957 3.99254C16.3531 3.04635 15.0413 3.01339 12.4175 2.94747C10.8004 2.90683 9.19926 2.90683 7.58219 2.94746C4.95845 3.01338 3.64657 3.04633 2.70397 3.99253C1.76136 4.93873 1.73412 6.21603 1.67964 8.7706C1.66212 9.59202 1.66212 10.4086 1.67964 11.23Z"
        stroke="#424242"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default MessageIcon;
